import { useInView } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';

const NumberCounter = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const counterRef = useRef(null);
  const isInView = useInView(counterRef, { once: true, threshold: 0.5 });
  
  useEffect(() => {
    if (!isInView || hasAnimated || !end) return;
    
    setHasAnimated(true);
    let startTimestamp;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = timestamp - startTimestamp;
      
      const nextCount = Math.min(
        Math.floor((progress / duration) * end),
        end
      );
      
      setCount(nextCount);
      
      if (progress < duration) {
        requestAnimationFrame(step);
      }
    };
    
    requestAnimationFrame(step);
  }, [end, duration, isInView, hasAnimated]);
  
  return (
    <span ref={counterRef}>
      {count}
    </span>
  );
};

export default NumberCounter;
